import { faker } from '@faker-js/faker';
import { sample } from 'lodash';
// eslint-disable-next-line import/no-unresolved
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const queuescheckin = [...Array(50)].map((_, index) => ({
  id: faker.datatype.uuid(),
  pictureUrl: `/assets/images/avatars/avatar_${index + 1}.jpg`,
  displayName: faker.name.fullName(),
  rank: faker.name.jobTitle(),
  name: faker.name.firstName(),
  surname: faker.name.lastName(),
  unit: {  abbr: faker.name.jobArea() },
  role: faker.helpers.arrayElements(Object.keys(ROLES), 1)
}));

export default queuescheckin;
